export default function FileIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="37"
      height="37"
      viewBox="0 0 37 37"
      fill="none"
    >
      <path
        d="M21.3706 3.32007H9.1585C8.34878 3.32007 7.57223 3.64479 6.99968 4.2228C6.42713 4.8008 6.10547 5.58475 6.10547 6.40218V31.059C6.10547 31.8765 6.42713 32.6604 6.99968 33.2384C7.57223 33.8164 8.34878 34.1411 9.1585 34.1411H27.4767C28.2864 34.1411 29.0629 33.8164 29.6355 33.2384C30.208 32.6604 30.5297 31.8765 30.5297 31.059V12.5664L21.3706 3.32007Z"
        stroke="#7B76FF"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21.3711 3.32007V12.5664H30.5302"
        stroke="#7B76FF"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M24.427 20.2708H12.2148"
        stroke="#7B76FF"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M24.427 26.4358H12.2148"
        stroke="#7B76FF"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.2667 14.1067H13.7408H12.2148"
        stroke="#7B76FF"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
